module.exports = __webpack_public_path__ + "static/media/LavuLogoDark.c14027eb.svg";